import { render, staticRenderFns } from "./FormularioFotos.vue?vue&type=template&id=83134a5a&scoped=true&"
import script from "./FormularioFotos.vue?vue&type=script&lang=js&"
export * from "./FormularioFotos.vue?vue&type=script&lang=js&"
import style0 from "./FormularioFotos.vue?vue&type=style&index=0&id=83134a5a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83134a5a",
  null
  
)

export default component.exports